/**
 * Anchos mínimos (px) de los rangos de pantalla de E-011 RN-1, alineados con
 * los breakpoints por defecto de Tailwind (`md`, `xl`):
 * móvil < md ≤ mediana < xl ≤ grande.
 *
 * Única fuente de estos números en TS: el shell decide su modo con
 * `ViewportService`, no con clases `md:` / `xl:` repetidas en plantillas.
 */
export const BREAKPOINTS = {
  md: 768,
  xl: 1280,
} as const;

/** Media query `(min-width: Npx)` para un breakpoint de `BREAKPOINTS`. */
export function minWidthQuery(breakpoint: keyof typeof BREAKPOINTS): string {
  return `(min-width: ${BREAKPOINTS[breakpoint]}px)`;
}
